/**
 * Sync inline PDP rating with Shopify Reviews metafields or Impulse reviews section.
 */
(function () {
  if (!document.documentElement.classList.contains('header-layout--impulse')) return;

  function parseRating(value) {
    const avg = parseFloat(String(value).replace(',', '.'));
    if (Number.isNaN(avg) || avg <= 0) return null;

    const floor = Math.floor(avg);
    let decimal = 0;
    const fraction = avg % 1;
    if (fraction >= 0.3 && fraction <= 0.7) decimal = 0.5;
    else if (fraction > 0.7) decimal = 1;

    return { floor, decimal, max: 5 };
  }

  function applyRatingToStars(stars, parsed, max) {
    if (!stars || !parsed) return;
    stars.style.setProperty('--rating', String(parsed.floor));
    stars.style.setProperty('--rating-max', String(max || parsed.max || 5));
    stars.style.setProperty('--rating-decimal', String(parsed.decimal));
    stars.dataset.ratingValue = String(parsed.floor + parsed.decimal);
    stars.dataset.ratingDecimal = String(parsed.decimal);
  }

  function syncFromReviewsSummary(wrapper) {
    const reviewsSection = document.getElementById('ImpulseProductReviews');
    if (!reviewsSection) return;

    const average = reviewsSection.dataset.averageRating;
    const total = reviewsSection.dataset.totalReviews;
    const parsed = parseRating(average);
    const stars = wrapper.querySelector('.impulse-product-rating__stars');
    applyRatingToStars(stars, parsed, 5);

    const countEl = wrapper.querySelector('[data-rating-count]');
    if (countEl && total) {
      const label = countEl.dataset.reviewsLabel || 'AVALIAÇÕES';
      countEl.textContent = `${total} ${label}`;
    }
  }

  function initProductRating() {
    document.querySelectorAll('.impulse-product-rating[data-rating-source="summary"]').forEach(syncFromReviewsSummary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRating);
  } else {
    initProductRating();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector?.('.impulse-product-rating')) initProductRating();
  });
})();
